import React from 'react'
import { render as ReactRender, hydrate } from 'react-dom'
import GuardXLogger from 'guard-x-logger'
import p from './pass'

// config
import { config } from './Config/ConfigLoader'

const __DEV__ = DEV

import createStore from './store/createStore'
import AppContainer from './Containers/AppContainer'
import packageJson from '../package.json'

const basenameElement = document.getElementById('basename')
let basename = '/'
if (basenameElement) {
  basename = basenameElement.value
  //  basenameElement.parentNode.removeChild(basenameElement)
}

const tokenElement = document.getElementById('token')
const token = tokenElement.value
// tokenElement.parentNode.removeChild(tokenElement)

const affiliateElement = document.getElementById('affiliate')
const affiliate = affiliateElement ? affiliateElement.value : ''

const subProductNameElement = document.getElementById('subProductName')

let turnOffHydrate = document.getElementById('turnOffHydrate')
turnOffHydrate = turnOffHydrate ? turnOffHydrate.value === 'true' : false

// ========================================================
// Store Instantiation
// ========================================================
const initialState = window.__PRELOADED_STATE__ || {}
const isPreloadedState = !!window.__PRELOADED_STATE__
delete window.__PRELOADED_STATE__
const store = createStore(initialState, turnOffHydrate)

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('app')

const options = {
  appCodeName: navigator.appCodeName,
  appName: navigator.appName,
  appVersion: navigator.appVersion,
  cookieEnabled: navigator.cookieEnabled,
  language: navigator.language,
  onLine: navigator.onLine,
  platform: navigator.platform,
  product: navigator.product,
  productSub: navigator.productSub,
  userAgent: navigator.userAgent,
  vendor: navigator.vendor,
  vendorSub: navigator.vendorSub,
  version: packageJson.version,
}
GuardXLogger.setup({
  ...options,
  apiKey: config.getConfig('guardXApiKey'),
  debug: DEV,
  release: packageJson.version,
  stackdriver: true,
  tags: options,
})

let render = () => {
  if (typeof window.scrollTo === 'undefined') {
    window.scrollTo = () => {}
  }
  if (MOUNT_NODE.hasChildNodes() && !turnOffHydrate) {
    hydrate(
      <AppContainer
        affiliate={affiliate}
        basename={basename}
        isPreloadedState={isPreloadedState}
        p={p.charAt(0)}
        store={store}
        token={token}
        turnOffHydrate={turnOffHydrate}
        subProductName={subProductNameElement && subProductNameElement.value ? subProductNameElement.value : 'default'}
      />,
      MOUNT_NODE,
    )
  } else {
    ReactRender(
      <AppContainer
        affiliate={affiliate}
        basename={basename}
        isPreloadedState={isPreloadedState}
        p={p.charAt(0)}
        store={store}
        token={token}
        turnOffHydrate={turnOffHydrate}
        subProductName={subProductNameElement && subProductNameElement.value ? subProductNameElement.value : 'default'}
      />,
      MOUNT_NODE,
    )
  }
}

// ========================================================
// Developer Tools Setup
// ========================================================
if (__DEV__) {
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    // window.__REDUX_DEVTOOLS_EXTENSION__.open()
  }
}

// ========================================================
// Go!
// ========================================================
render()
